import { AgentExecution } from '~/features/ask-anything/agentic-ai/types';
import { sylvanus } from '~/services/serviceInstances';

import { GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiResponse } from '../../types/sylvanus/agentExecution';
import { mapServerAgentExecutionToAgentExecution } from './transformers';

type Request = {
  agentExecutionId: string;
};

export const getAgentExecution = async ({
  agentExecutionId,
}: Request): Promise<AgentExecution> => {
  const response =
    await sylvanus.get<GetExecutionApiV1AgentExecutionAgentExecutionIdGetApiResponse>(
      `/agent-execution/${agentExecutionId}`,
    );

  return mapServerAgentExecutionToAgentExecution(response);
};
